import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconSparkleFilled24 = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		fill: "currentColor",
		children: /* @__PURE__ */ _jsx("path", { d: "m13 10-1.629-4.072a1.477 1.477 0 0 0-2.742 0L7 10l-4.072 1.629a1.477 1.477 0 0 0 0 2.742L7 16l1.629 4.072a1.477 1.477 0 0 0 2.742 0L13 16l4.072-1.629a1.477 1.477 0 0 0 0-2.742zM19.813 4.188 19.1 2.406a.646.646 0 0 0-1.2 0l-.712 1.781-1.782.713a.646.646 0 0 0 0 1.2l1.781.713.713 1.78a.646.646 0 0 0 1.2 0l.712-1.78 1.782-.713a.646.646 0 0 0 0-1.2z" })
	})
});
const ForwardRef = forwardRef(SvgIconSparkleFilled24);
export default ForwardRef;
